import type { RootState } from "@/store";
import { Status as MfaStatus } from "@/store/apis/adminApi.generated";
import type { Permission } from "@/store/apis/adminApi.types";

export const selectAdmin = (state: RootState) => state.auth.admin;
export const selectAccessToken = (state: RootState) => state.auth.accessToken;
export const selectRefreshToken = (state: RootState) => state.auth.refreshToken;
export const selectMfa = (state: RootState) => state.auth.mfa;
export const selectSessionLost = (state: RootState) => state.auth.sessionLost;

/**
 * Autenticado = tenemos access token + admin + MFA verificado. Antes de
 * verificar MFA la sesión es "aal1" y no permite operar (el back
 * rechaza con `ERR_MFA_REQUIRED`).
 */
export const selectIsAuthenticated = (state: RootState) =>
  Boolean(
    state.auth.accessToken && state.auth.admin && state.auth.mfa?.status === MfaStatus.Verified,
  );

/** Sesión aal1: tiene tokens pero MFA no está verificado todavía. */
export const selectIsAal1 = (state: RootState) =>
  Boolean(
    state.auth.accessToken &&
    state.auth.mfa?.status &&
    state.auth.mfa.status !== MfaStatus.Verified,
  );

export const selectHasPermission =
  (permission: Permission) =>
  (state: RootState): boolean =>
    Boolean(state.auth.admin?.permissions?.includes(permission));

export const selectHasAnyPermission =
  (permissions: readonly Permission[]) =>
  (state: RootState): boolean => {
    const owned = state.auth.admin?.permissions ?? [];
    return permissions.some((p) => owned.includes(p));
  };
